/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BCMOsisRuleFormDataTravelDateRestriction
 */
export interface BCMOsisRuleFormDataTravelDateRestriction {
    /**
     * 
     * @type {object}
     * @memberof BCMOsisRuleFormDataTravelDateRestriction
     */
    from?: object | null;
    /**
     * 
     * @type {object}
     * @memberof BCMOsisRuleFormDataTravelDateRestriction
     */
    to?: object | null;
}

export function BCMOsisRuleFormDataTravelDateRestrictionFromJSON(json: any): BCMOsisRuleFormDataTravelDateRestriction {
    return BCMOsisRuleFormDataTravelDateRestrictionFromJSONTyped(json, false);
}

export function BCMOsisRuleFormDataTravelDateRestrictionFromJSONTyped(json: any, ignoreDiscriminator: boolean): BCMOsisRuleFormDataTravelDateRestriction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
    };
}

export function BCMOsisRuleFormDataTravelDateRestrictionToJSON(value?: BCMOsisRuleFormDataTravelDateRestriction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'from': value.from,
        'to': value.to,
    };
}


